
<router-outlet></router-outlet>
<notifier-container style="position:absolute"></notifier-container>